import { Box } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import React from "react";
import {
  COLOR_DARK_GREEN,
  COLOR_DARK_RED,
  COLOR_GREY_10,
} from "shared/theme/colors";
import { ArrowCurvedDownIcon } from "shared/theme/icons/ArrowCurvedDownIcon";
import { ArrowCurvedUpIcon } from "shared/theme/icons/ArrowCurvedUpIcon";
import { ArrowLongForwardIcon } from "shared/theme/icons/ArrowLongForwardIcon";
import {
  StyledGreyText,
  StyledGreyCategoryContainer,
  StyledBlackCountText,
  StyledComparisonIndicator,
  StyledBlackText,
} from "./styled";

const renderIcon = (
  isIncreased: boolean,
  isLowerRatio: boolean,
  isEqual: boolean,
) => {
  if (isEqual) {
    return <ArrowLongForwardIcon color={COLOR_GREY_10} />;
  } else if (isIncreased) {
    return (
      <ArrowCurvedUpIcon
        color={isLowerRatio ? COLOR_GREY_10 : COLOR_DARK_RED}
      />
    );
  } else {
    return (
      <ArrowCurvedDownIcon
        color={isLowerRatio ? COLOR_GREY_10 : COLOR_DARK_GREEN}
      />
    );
  }
};

export const getComparingSectionColumns = (): GridColDef[] => [
  {
    field: "id",
    headerName: "",
    width: 50,
    editable: false,
    sortable: false,
    renderCell: (params) => <StyledGreyText>{params.value}</StyledGreyText>,
  },
  {
    field: "category",
    headerName: "Category",
    flex: 1,
    headerAlign: "left",
    editable: false,
    sortable: false,
    renderCell: (params) => (
      <StyledGreyCategoryContainer>{params.value}</StyledGreyCategoryContainer>
    ),
  },
  {
    field: "thisWeekCount",
    headerName: "Total Inquiries",
    width: 150,
    headerAlign: "center",
    align: "center",
    editable: false,
    sortable: false,
    renderCell: (params) => (
      <StyledBlackCountText>{params.value}</StyledBlackCountText>
    ),
  },
  {
    field: "change",
    headerName: "Change per week",
    width: 200,
    headerAlign: "right",
    sortable: false,
    editable: false,
    filterable: false,
    renderCell: (params) => {
      const row = params.row;
      const isIncreased = row.thisWeekCount > row.lastWeekCount;
      const isEqual = row.thisWeekCount === row.lastWeekCount;
      const isZeroTicketsTotal =
        row.thisWeekCount === 0 && row.lastWeekCount === 0;
      const isLowerRatio =
        (row.weeklyPercentageDifference > 0 &&
          row.weeklyPercentageDifference < 1) ||
        row.weeklyPercentageDifference === 0;
      const countDifference = row.thisWeekCount - row.lastWeekCount;

      return (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end",
            width: "100%",
          }}
        >
          {row.lastWeekCount > 0 && (
            <StyledComparisonIndicator
              isIncreased={isIncreased}
              isLowerRatio={isLowerRatio}
            >
              {renderIcon(isIncreased, isLowerRatio, isEqual)}
              {row.weeklyPercentageDifference === 0
                ? "0.0"
                : row.weeklyPercentageDifference}
              %
            </StyledComparisonIndicator>
          )}
          {isZeroTicketsTotal ? (
            <StyledComparisonIndicator isIncreased={false} isLowerRatio={true}>
              <ArrowLongForwardIcon color={COLOR_GREY_10} />
              0.0%
            </StyledComparisonIndicator>
          ) : (
            row.weeklyPercentageDifference !== 0 && (
              <StyledBlackText>
                {`(${isIncreased ? "+" : ""}${countDifference} inquiries)`}
              </StyledBlackText>
            )
          )}
        </Box>
      );
    },
  },
];
